import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";


import moment from 'moment';
import { API_ENDPOINT } from '../../../constants';
import ErrorModal_v2 from '../../../components/errorModal_v2';
import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import SelectWithCheckbox from '../../../components/forms/fields/selectWithCheckbox';
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import ErrorModal from '../../../components/errorModal';
import { addMinutesToTime } from '../helper';




function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

class UpdateFreeEvent extends React.Component {

    constructor(props) {
        super(props);

        this.player = React.createRef();
        this.state = {
            ...props.initialData,
            webBookingForms: [],
            clinicians: [],
            minTime: '07:00',
            maxTime: '18:00',
        }
    }
    getWorkingHours = () => {
        const doctorId = this.state.doctorId;
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;

        if (!doctorId || !clinicId || !groupId) return;

        const obj = {
            clinicianId: doctorId,
            clinicId: clinicId,
            groupId: groupId
        };

        fetch(API_ENDPOINT + `/data/calendar/clinician/working-hours`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {

            let { minTime, maxTime } = result;
            if (!minTime) minTime = '07:00';
            if (!maxTime) maxTime = '18:00';

            let setObj = {};
            if (minTime !== this.state.minTime) {
                setObj.minTime = minTime;
            }
            if (maxTime !== this.state.maxTime) {
                setObj.maxTime = maxTime;
            }
            if (Object.keys(setObj).length > 0) {
                this.setState(setObj)
            }

        })
    }


    stopAnimation = () => {
        this.player.current.play();
    };



    setInitialData = () => {
        this.fetchWebBookingForms();
        // this.getClinicians();
    }
    // getClinicians = () => {
    //     const clinicId = this.props.selectedClinic;
    //     if (!clinicId) return;

    //     this.setState({ clinicians: [] }, () => {
    //         fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
    //             method: 'GET',
    //             headers: {
    //                 'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
    //                 'content-type': 'application/json'
    //             }
    //         }).then(parseJSON).then(({ result, status }) => {
    //             if (result?.clinicians?.length) {
    //                 this.setState({ clinicians: result.clinicians }, () => {
    //                     if (!this.state.doctorId && this.props.doctorId && this.state.clinicians?.find(el => el._id === this.props.doctorId)) {
    //                         this.setState({ doctorId: this.props.doctorId });
    //                     }
    //                 });
    //             }
    //         })
    //     });
    // }


    fetchWebBookingForms = () => {
        if (this.state.data?.doctor) {
            this.setState({ webBookingForms: [] }, () => {
                fetch(API_ENDPOINT + '/working-hours/web-booking-forms', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        doctor: this.state.data?.doctor,
                        group: this.props.selectedGroup,
                        clinic: this.props.selectedClinic
                    })
                }).then(parseJSON).then(({ result, status }) => {
                    if (result?.length) {
                        this.setState({ webBookingForms: result })
                    }
                })
            })
        }


    }




    componentDidMount() {

        if (this.props.isOpen) {
            let data = this.props.isOpen;
            let doctorId = data.doctor ?? null;;
            if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
                let initialTime = this.generateInitialTime();
                data = {
                    ...initialTime,
                    ...data
                }
            }
            this.setState({ data: data, doctorId }, () => {
                this.getWorkingHours();
                this.setInitialData();
            })
        }

    }
    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.isOpen !== this.props.isOpen) {
        //     let data = this.props.isOpen;
        //     if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
        //         let initialTime = this.generateInitialTime();
        //         data = {
        //             ...initialTime,
        //             ...data
        //         }
        //     }

        //     this.setState({ data: data })
        // }

    }
    componentWillUnmount() {

    }

    toggle = (fetchItems = false) => {
        if (this.props.toggle) {
            this.props.toggle(fetchItems);
        }
    }
    formatDate = (date, format) => {
        if (!date || !format) return '';
        let dateString = date?.split(' ')?.[0];
        let timeString = date?.split(' ')?.[1];

        let DD = dateString?.split('/')[1];
        let MM = dateString?.split('/')[0];
        let YYYY = dateString?.split('/')[2];
        let HH = timeString?.split(':')[0];
        let mm = timeString?.split(':')[1];

        let formattedDate = format
            .replace('DD', DD)
            .replace('MM', MM)
            .replace('YYYY', YYYY)
            .replace('HH', HH)
            .replace('mm', mm);

        return formattedDate;

    }


    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }
    checkRecurring = (data) => {
        let obj = { ...data }
        let recurringObj = {};
        if (obj.frequencyType) {
            recurringObj.frequencyType = obj.frequencyType;
            delete obj.frequencyType;
        }
        if (obj.frequencyDayText) {
            if (recurringObj.frequencyType == 'day')
                recurringObj.frequencyDayText = obj.frequencyDayText;
            delete obj.frequencyDayText;
        }
        if (obj.frequencyMonthScheduled) {
            if (recurringObj.frequencyType == 'month')
                recurringObj.frequencyMonthScheduled = obj.frequencyMonthScheduled;
            delete obj.frequencyMonthScheduled;
        }
        if (obj.frequencyDayScheduledDateFrom) {
            if (recurringObj.frequencyType == 'day')
                recurringObj.frequencyDayScheduledDateFrom = obj.frequencyDayScheduledDateFrom;
            delete obj.frequencyDayScheduledDateFrom;
        }
        if (obj.frequencyDayScheduledDateTo) {
            if (recurringObj.frequencyType == 'day')
                recurringObj.frequencyDayScheduledDateTo = obj.frequencyDayScheduledDateTo;
            delete obj.frequencyDayScheduledDateTo;
        }
        if (obj.frequencyMonthScheduledDateFrom) {
            if (recurringObj.frequencyType == 'month')
                recurringObj.frequencyMonthScheduledDateFrom = obj.frequencyMonthScheduledDateFrom;
            delete obj.frequencyMonthScheduledDateFrom;
        }
        if (obj.frequencyMonthScheduledDateTo) {
            if (recurringObj.frequencyType == 'month')
                recurringObj.frequencyMonthScheduledDateTo = obj.frequencyMonthScheduledDateTo;
            delete obj.frequencyMonthScheduledDateTo;
        }
        if (obj.frequencyWeekScheduledDateFrom) {
            if (recurringObj.frequencyType == 'week')
                recurringObj.frequencyWeekScheduledDateFrom = obj.frequencyWeekScheduledDateFrom;
            delete obj.frequencyWeekScheduledDateFrom;
        }
        if (obj.frequencyWeekScheduledDateTo) {
            if (recurringObj.frequencyType == 'week')
                recurringObj.frequencyWeekScheduledDateTo = obj.frequencyWeekScheduledDateTo;
            delete obj.frequencyWeekScheduledDateTo;
        }
        if (obj.checkedMonday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedMonday = obj.checkedMonday; delete obj.checkedMonday; }
        if (obj.checkedTuesday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedTuesday = obj.checkedTuesday; delete obj.checkedTuesday; }
        if (obj.checkedWednesday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedWednesday = obj.checkedWednesday; delete obj.checkedWednesday; }
        if (obj.checkedThursday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedThursday = obj.checkedThursday; delete obj.checkedThursday; }
        if (obj.checkedFriday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedFriday = obj.checkedFriday; delete obj.checkedFriday; }
        if (obj.checkedSaturday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedSaturday = obj.checkedSaturday; delete obj.checkedSaturday; }
        if (obj.checkedSunday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedSunday = obj.checkedSunday; delete obj.checkedSunday; }

        obj.recurringObj = recurringObj;
        return obj;
    }

    setData = (data, callback) => {
        this.setState({ data }, () => {
            if (callback) {
                callback();
            }
        })
    }

    deletePatientTime = (data) => {
        let date = data.date;
        if (data.recurring) {
            if (data.frequencyType == 'day') {
                date = data.frequencyDayScheduledDateFrom;
            } else if (data.frequencyType == 'week') {
                date = data.frequencyWeekScheduledDateFrom;
            } else if (data.frequencyType == 'month') {
                date = data.frequencyMonthScheduledDateFrom;
            }
        }

        if (data && data.recurring) {
            data = this.checkRecurring(data);
        }

        this.setState({
            loadingDelete: true
        }, () => {

            fetch(API_ENDPOINT + '/working-hours/patient-time/delete/v2', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                    endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                    startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    doctor: data?.doctor ? data?.doctor : this.props.uData._id,
                    group: this.props.selectedGroup,
                    clinic: this.props.selectedClinic,
                    recurring: data.recurring,
                    recurringObj: data.recurringObj,
                })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loadingDelete: false
                    })
                } else {
                    this.setState({
                        scheduleModal: null,
                        schedulePatientTime: null,
                        loadingDelete: false

                    }, () => {
                        this.toggle(true);
                    })
                }

            })
        })
    }
    updateEvent = (data) => {
        const doctorId = this.state.doctorId ?? data?.doctor ?? null;
        if (!doctorId) return;

        const eventId = data?.id ?? data?._id ?? null;

        let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();

        if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {

                fetch(API_ENDPOINT + '/working-hours/update/' + eventId, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        allActiveForms: data.allActiveForms && data.type !== 'event' ? data.allActiveForms : false,
                        eventForms: data.eventForms ? data.eventForms : [],
                        type: data.type,
                        startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                        endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                        startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        title: data.title,
                        titleDoctor: data.titleDoctor,
                        doctor: doctorId,
                        // patientNote: data.patientNote,
                        // patientControlNote: data.patientControlNote,
                        // additionalDoctors: data.additionalDoctors,
                        // closeCaseManually: data.closeCaseManually,
                        // guests: data.guests,
                        // colleagues: data.colleagues
                    })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false,
                            creatingEvent: false
                        })
                    } else {

                        this.setState({
                            loading: false,
                            creatingEvent: false
                        }, () => {
                            if (this.props.addToUpdatedEvents) {
                                this.props.addToUpdatedEvents([eventId]);
                            }
                            this.toggle(true)
                        })
                    }

                })
            })
        } else {
            this.setState({
                wrongDate: true,
                creatingEvent: false
            })


        }

    }

    render() {
        const isOpen = this.props.isOpen ? true : false;
        if (!isOpen || !this.state.data) return null;

        const groupData = this.getGroupData();
        const visitTemplates = groupData?.visitTemplates ?? null;
        const availabilityTemplatesEnabled = this.state.availabilityTemplates?.length && visitTemplates ? true : false;

        const eventMeetings = groupData?.eventMeetings ?? false;
        const availabilityInformationToClinicians = groupData?.bookingSettings?.availabilityInformationToClinicians ?? null;

        const doctorId = this.state.doctorId ?? null;

        const disabledSaveButton = !this.state.loading && doctorId && this.state.data && this.state.data.type &&
            (this.state.data?.type !== 'template' || (this.state.data?.type === 'template' && this.state.data?.selectedAvailabilityTemplate?.id))
            && (!this.state.data.frequencyType || (this.state.data.frequencyType &&
                (this.state.data.frequencyType == 'day' && this.state.data.frequencyDayText && this.state.data.frequencyDayScheduledDateFrom && this.state.data.frequencyDayScheduledDateTo)
                || (this.state.data.frequencyType == 'month' && this.state.data.frequencyMonthScheduled && this.state.data.frequencyMonthScheduledDateFrom && this.state.data.frequencyMonthScheduledDateTo)
                || (this.state.data.frequencyType == 'week' && (this.state.data.checkedMonday || this.state.data.checkedTuesday || this.state.data.checkedThursday || this.state.data.checkedWednesday || this.state.data.checkedFriday || this.state.data.checkedSaturday || this.state.data.checkedSunday) && this.state.data.frequencyWeekScheduledDateFrom && this.state.data.frequencyWeekScheduledDateTo)
            )) && !this.state.creatingEvent
            ? false : true;

        const { minTime, maxTime } = this.state;

        return (
            <>
                <Modal isOpen={isOpen} centered>
                    <ModalHeader
                        toggle={() => this.toggle()}
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>}
                    >
                        {'Enter availability'.translate(this.props.lang)}
                    </ModalHeader>
                    <ModalBody>

                        <FormGroup>
                            <Label>{'Type'.translate(this.props.lang) + '*'}</Label>
                            <Input type='select' value={this.state.data.type} disabled onChange={(e) => {
                                let val = false
                                if (e.target.value != -1) {
                                    val = e.target.value
                                }
                                let data = this.state.data
                                data.type = val;
                                this.setData(data)

                            }}>
                                <option value={-1}>{'Select event type'.translate(this.props.lang)}</option>
                                <option value={'event'}>{'Schedule event'.translate(this.props.lang)}</option>
                                <option value={'free'}>{'Mark as available'.translate(this.props.lang)}</option>
                                {
                                    availabilityTemplatesEnabled || this.state.data?.type === 'template' ?
                                        <option value={'template'}>{'Add availability template'.translate(this.props.lang)}</option>
                                        :
                                        null
                                }
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>{'Title'.translate(this.props.lang)}</Label>
                            <Input type='text' value={this.state.data.title} onChange={(e) => {
                                let data = this.state.data
                                data.title = e.target.value
                                this.setData(data)
                            }} />
                        </FormGroup>

                        <FormGroup>
                            <Label>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        {'Enable booking by patient'.translate(this.props.lang)}
                                    </div>
                                    <div className="modal-header-tooltip"> <Isvg src={infoIcon} className="info-text" /> <div className="chat-icons-tooltip">{'Leave empty if time-slot should not be made available for patients to book'.translate(this.props.lang)}</div> </div>

                                </div>

                            </Label>
                            <Checkbox label={'All active forms'.translate(this.props.lang)} checked={this.state.data.allActiveForms} onChange={(e) => {
                                let data = this.state.data
                                data.allActiveForms = e.target.checked
                                this.setData(data)
                            }} />
                            <SelectWithCheckbox disabled={this.state.data.allActiveForms} checkAll={this.state.data.allActiveForms} placeHolder={'Search reason'.translate(this.props.lang)} values={this.state.webBookingForms.map(item => { return { name: item.name, value: item._id, additionalInfo: item?.duration ? `${item.duration} ${'min'.translate(this.props.lang)}` : null } })} value={this.state.data.eventForms}
                                onChange={(value) => {
                                    if (!this.state.data.allActiveForms) {
                                        let data = this.state.data
                                        data.eventForms = value

                                        this.setData(data)
                                    }

                                }} />
                        </FormGroup>
                        {
                            !this.state.data.frequencyType ?
                                <DatePicker
                                    label={'Date'.translate(this.props.lang)}
                                    value={this.state.data.date}
                                    onChange={(e) => {
                                        let data = this.state.data;
                                        data.date = e;
                                        this.setData(data)
                                        if (Math.floor(new Date(this.state.data.date + ' ' + this.state.data.startTime) / 1000) > Math.floor(new Date(this.state.data.endDate + ' ' + this.state.data.endTime) / 1000)) {
                                            data.endDate = this.state.data.date
                                            this.setData(data)
                                        }
                                    }}
                                />
                                :
                                null
                        }



                        <div className='time-wrap' style={{ alignItems: this.state.data.type === 'template' && this.state.data.selectedAvailabilityTemplate?.id ? 'center' : 'flex-start' }}>
                            <div className='time-component-wrap'>
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.data.startTime}
                                        // minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                        // maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        minValue={minTime}
                                        maxValue={addMinutesToTime(maxTime, -5)}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let data = this.state.data;
                                            data.startTime = timeString

                                            let startTimeSplit = data.startTime.split(":");
                                            let endTimeSplit = data.endTime.split(":");


                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setData(data)
                                            } else {
                                                data.endTime = Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60
                                                // data.endTime = validateTime(data.endTime);
                                                const padded = data?.endTime?.split?.(':');
                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                    const h = padded[0]?.padStart?.(2, '0');
                                                    const m = padded[1]?.padStart?.(2, '0');
                                                    if (h && m) data.endTime = `${h}:${m}`;
                                                }
                                                this.setData(data)
                                            }


                                        }}
                                    />

                                </FormGroup>
                                {
                                    this.state.data?.type !== 'template' ?
                                        <FormGroup className="timepicker-container timepicker-wide">
                                            <Label>{'End time'.translate(this.props.lang)}</Label>
                                            &nbsp;
                                            <TimePickerV2
                                                getStringDateTs={this.props.getStringDateTs}
                                                format={'HH:mm'}
                                                value={this.state.data.endTime}
                                                minValue={Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60}
                                                // maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                                maxValue={maxTime}
                                                flag={0}
                                                onChange={(time1, timeString) => {

                                                    let data = this.state.data;
                                                    data.endTime = timeString

                                                    let startTimeSplit = data.startTime.split(":");
                                                    let endTimeSplit = data.endTime.split(":");

                                                    let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                    let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                    if (startTimeHourMinute < endTimeHourMinute) {
                                                        this.setData(data)

                                                    } else {
                                                    }

                                                }}
                                            />

                                        </FormGroup>
                                        :
                                        null
                                }


                            </div>
                            {
                                this.state.data?.type === 'free' && availabilityInformationToClinicians ?
                                    <div className='availability-information-to-clinicians-component-wrap'>
                                        <h6>{'Information'.translate(this.props.lang)}</h6>
                                        <div className='availability-information-to-clinicians-component'>
                                            <p>{truncateString(availabilityInformationToClinicians)}</p>
                                        </div>
                                    </div>
                                    :
                                    null
                            }

                        </div>


                        {
                            !this.state.data.id ?
                                <FormGroup>
                                    <Label >{'Frequency'.translate(this.props.lang)}</Label>
                                    <Input type='select'
                                        value={this.state.data.frequencyType}

                                        onChange={(e) => {
                                            let val = null;
                                            if (e.target.value != -1) {
                                                val = e.target.value;
                                            }
                                            let data = this.state.data;
                                            data.frequencyType = val;
                                            let date = moment(new Date()).format(this.props.dateFormat);
                                            if (data.date) {
                                                date = moment(new Date(data.date)).format(this.props.dateFormat);
                                            }
                                            if (val == 'day') {
                                                data.frequencyDayScheduledDateFrom = date;
                                                data.frequencyDayScheduledDateTo = date
                                                data.recurring = true
                                            } else if (val == 'week') {
                                                data.frequencyWeekScheduledDateFrom = date;
                                                data.frequencyWeekScheduledDateTo = moment.unix(Math.floor(new Date(date).getTime() / 1000) + 7 * 24 * 60 * 60).format(this.props.dateFormat);
                                                data.recurring = true

                                            } else if (val == 'month') {
                                                data.frequencyMonthScheduledDateFrom = date;
                                                data.frequencyMonthScheduledDateTo = moment.unix(Math.floor(new Date(date).getTime() / 1000) + 30 * 24 * 60 * 60).format(this.props.dateFormat);
                                                data.recurring = true

                                            } else {
                                                data.recurring = false

                                            }
                                            this.setData(data)
                                            this.setState({
                                                errorEvent: null
                                            })
                                        }}>
                                        <option value={-1}>
                                            {'Choose frequency'.translate(this.props.lang)}
                                        </option>
                                        <option value={'day'}>
                                            {'Day'.translate(this.props.lang)}
                                        </option>
                                        <option value={'week'}>
                                            {'Week'.translate(this.props.lang)}
                                        </option>
                                        <option value={'month'}>
                                            {'Month'.translate(this.props.lang)}
                                        </option>
                                    </Input>

                                </FormGroup>
                                :
                                null
                        }

                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                        {this.state.data.frequencyType == 'day' ?
                            <div>
                                <Row>
                                    <Col lg="12">
                                        <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', marginBottom: 5, marginTop: 10 }}>
                                            <Label style={{ marginRight: 5 }}>{'Every'.translate(this.props.lang)}</Label>
                                            <Input style={{ width: '25%' }} type='text' value={this.state.data.frequencyDayText} onChange={(e) => {
                                                let value = e.target.value
                                                value = value.replace(/[^0-9]/g, '')

                                                let data = this.state.data;
                                                data.frequencyDayText = value;
                                                this.setData(data)
                                            }} />
                                            <Label style={{ marginLeft: 5 }}>{'day(s)'.translate(this.props.lang) + '*'}</Label>
                                        </div>
                                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                        <DatePicker
                                            label={'Start date'.translate(this.props.lang) + '*'}
                                            minDate={new Date()}
                                            dateFormat={this.props.dateFormat}
                                            value={this.state.data.frequencyDayScheduledDateFrom ? this.state.data.frequencyDayScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.frequencyDayScheduledDateFrom = e;
                                                this.setData(data)

                                                if (this.state.data.frequencyDayScheduledDateTo && this.state.data.frequencyDayScheduledDateFrom) {
                                                    let dateTo = new Date(this.state.data.frequencyDayScheduledDateTo)
                                                    let dateFrom = new Date(this.state.data.frequencyDayScheduledDateFrom)
                                                    if (dateFrom.getTime() > dateTo.getTime()) {
                                                        let data = this.state.data;
                                                        data.frequencyDayScheduledDateTo = this.state.data.frequencyDayScheduledDateFrom;
                                                        this.setData(data)
                                                    }
                                                } else if (!this.state.data.frequencyDayScheduledDateTo && this.state.data.frequencyDayScheduledDateFrom) {
                                                    let data = this.state.data;
                                                    data.frequencyDayScheduledDateTo = this.state.data.frequencyDayScheduledDateFrom;
                                                    this.setData(data)
                                                }

                                            }}
                                        />
                                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                    </Col>
                                    <Col lg="12">
                                        <div style={{ marginTop: 5 }}>
                                            <DatePicker
                                                label={'End date'.translate(this.props.lang) + '*'}
                                                dateFormat={this.props.dateFormat}
                                                minDate={new Date(this.state.data.frequencyDayScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.data.frequencyDayScheduledDateFrom) : new Date()}
                                                // maxDate={this.calculateMaxDateHotfix(this.state.data.frequencyDayScheduledDateFrom)}
                                                value={this.state.data.frequencyDayScheduledDateTo ? this.state.data.frequencyDayScheduledDateTo : moment(new Date()).format(this.props.dateFormat)}
                                                onChange={(e) => {
                                                    let data = this.state.data;
                                                    data.frequencyDayScheduledDateTo = e;
                                                    this.setData(data)

                                                }}
                                            />
                                        </div>
                                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                    </Col>
                                </Row>

                            </div>
                            : null}


                        {this.state.data.frequencyType == 'week' ?
                            <div style={{ marginTop: 10, marginBottom: 15 }}>
                                <Row>
                                    <Col lg="12">
                                        <Checkbox
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.checkedMonday = e.target.checked
                                                this.setData(data)
                                            }}
                                            checked={this.state.data.checkedMonday}
                                            label={'Monday'.translate(this.props.lang)}
                                        />
                                        <Checkbox
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.checkedTuesday = e.target.checked
                                                this.setData(data)
                                            }}
                                            checked={this.state.data.checkedTuesday}
                                            label={'Tuesday'.translate(this.props.lang)}
                                        />
                                        <Checkbox
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.checkedWednesday = e.target.checked
                                                this.setData(data)
                                            }}
                                            checked={this.state.data.checkedWednesday}
                                            label={'Wednesday'.translate(this.props.lang)}
                                        />
                                        <Checkbox
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.checkedThursday = e.target.checked
                                                this.setData(data)
                                            }}
                                            checked={this.state.data.checkedThursday}
                                            label={'Thursday'.translate(this.props.lang)}
                                        />
                                        <Checkbox
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.checkedFriday = e.target.checked
                                                this.setData(data)
                                            }}
                                            checked={this.state.data.checkedFriday}
                                            label={'Friday'.translate(this.props.lang)}
                                        />
                                        <Checkbox
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.checkedSaturday = e.target.checked
                                                this.setData(data)
                                            }}
                                            checked={this.state.data.checkedSaturday}
                                            label={'Saturday'.translate(this.props.lang)}
                                        />
                                        <Checkbox
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.checkedSunday = e.target.checked
                                                this.setData(data)
                                            }}
                                            checked={this.state.data.checkedSunday}
                                            label={'Sunday'.translate(this.props.lang)}
                                        />
                                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                        <DatePicker
                                            label={'Start date'.translate(this.props.lang) + '*'}
                                            minDate={new Date()}
                                            dateFormat={this.props.dateFormat}
                                            // completeStaeInput={this.state.data}
                                            value={this.state.data.frequencyWeekScheduledDateFrom ? this.state.data.frequencyWeekScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.frequencyWeekScheduledDateFrom = e;
                                                this.setData(data)

                                                if (this.state.data.frequencyWeekScheduledDateTo && this.state.data.frequencyWeekScheduledDateFrom) {
                                                    let dateTo = new Date(this.state.data.frequencyWeekScheduledDateTo)
                                                    let dateFrom = new Date(this.state.data.frequencyWeekScheduledDateFrom)
                                                    if (dateFrom.getTime() + 1000 * 60 * 60 * 24 * 7 > dateTo.getTime()) {
                                                        let data = this.state.data;
                                                        let date = new Date(this.state.data.frequencyWeekScheduledDateFrom)
                                                        date.setDate(date.getDate() + 7)
                                                        data.frequencyWeekScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                        this.setData(data)

                                                    }
                                                } else if (!this.state.data.frequencyWeekScheduledDateTo && this.state.data.frequencyWeekScheduledDateFrom) {
                                                    let data = this.state.data;
                                                    let date = new Date(this.state.data.frequencyWeekScheduledDateFrom)
                                                    date.setDate(date.getDate() + 7)
                                                    data.frequencyWeekScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                    this.setData(data)
                                                }

                                            }}
                                        />
                                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                    </Col>
                                    <Col lg="12">
                                        <DatePicker
                                            label={'End date'.translate(this.props.lang) + '*'}
                                            dateFormat={this.props.dateFormat}
                                            minDate={new Date(this.state.data.frequencyWeekScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.data.frequencyWeekScheduledDateFrom) : new Date(this.state.weekDate)}
                                            value={this.state.data.frequencyWeekScheduledDateTo ? this.state.data.frequencyWeekScheduledDateTo : moment(this.state.weekDate).format(this.props.dateFormat)}
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.frequencyWeekScheduledDateTo = e;
                                                this.setData(data)

                                            }}
                                        />
                                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                    </Col>
                                </Row>
                            </div>
                            : null}
                        {this.state.data.frequencyType == 'month' ?
                            <div style={{ marginBottom: 5 }}>
                                <Row>
                                    <Col lg="12">
                                        <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', marginBottom: 5, marginTop: 10 }}>
                                            <Label style={{ marginRight: 5 }}>{'Every'.translate(this.props.lang)}</Label>
                                            <Input style={{ width: '30%' }} type='select' onChange={(e) => {
                                                let val = null;
                                                if (e.target.value != '-1') {
                                                    val = e.target.value;
                                                }
                                                let data = this.state.data;
                                                data.frequencyMonthScheduled = val;
                                                this.setData(data)
                                            }}>
                                                <option value={'-1'}>

                                                </option>
                                                <option value={'1'}>
                                                    {'1st'.translate(this.props.lang)}
                                                </option>
                                                <option value={'2'}>
                                                    {'2nd'.translate(this.props.lang)}
                                                </option>
                                                <option value={'3'}>
                                                    {'3rd'.translate(this.props.lang)}
                                                </option>
                                                <option value={'4'}>
                                                    {'4th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'5'}>
                                                    {'5th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'6'}>
                                                    {'6th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'7'}>
                                                    {'7th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'8'}>
                                                    {'8th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'9'}>
                                                    {'9th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'10'}>
                                                    {'10th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'11'}>
                                                    {'11th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'12'}>
                                                    {'12th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'13'}>
                                                    {'13th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'14'}>
                                                    {'14th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'15'}>
                                                    {'15th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'16'}>
                                                    {'16th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'17'}>
                                                    {'17th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'18'}>
                                                    {'18th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'19'}>
                                                    {'19th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'20'}>
                                                    {'20th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'21'}>
                                                    {'21st'.translate(this.props.lang)}
                                                </option>
                                                <option value={'22'}>
                                                    {'22nd'.translate(this.props.lang)}
                                                </option>
                                                <option value={'23'}>
                                                    {'23rd'.translate(this.props.lang)}
                                                </option>
                                                <option value={'24'}>
                                                    {'24th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'25'}>
                                                    {'25th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'26'}>
                                                    {'26th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'27'}>
                                                    {'27th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'28'}>
                                                    {'28th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'29'}>
                                                    {'29th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'30'}>
                                                    {'30th'.translate(this.props.lang)}
                                                </option>
                                                <option value={'31'}>
                                                    {'31st'.translate(this.props.lang)}
                                                </option>

                                            </Input>
                                            <Label style={{ marginLeft: 5 }}>{'day of the month'.translate(this.props.lang) + '*'}</Label>
                                        </div>
                                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                        <DatePicker
                                            label={'Start date'.translate(this.props.lang) + '*'}
                                            minDate={new Date()}
                                            dateFormat={this.props.dateFormat}
                                            value={this.state.data.frequencyMonthScheduledDateFrom ? this.state.data.frequencyMonthScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.frequencyMonthScheduledDateFrom = e;
                                                this.setData(data)

                                                if (this.state.data.frequencyMonthScheduledDateTo && this.state.data.frequencyMonthScheduledDateFrom) {
                                                    let dateTo = new Date(this.state.data.frequencyMonthScheduledDateTo)
                                                    let dateFrom = new Date(this.state.data.frequencyMonthScheduledDateFrom)
                                                    if (dateFrom.getTime() + 1000 * 60 * 60 * 24 * 31 > dateTo.getTime()) {
                                                        let data = this.state.data;
                                                        let date = new Date(this.state.data.frequencyMonthScheduledDateFrom)
                                                        date.setDate(date.getDate() + 31)
                                                        data.frequencyMonthScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                        this.setData(data)

                                                    }
                                                } else if (!this.state.data.frequencyMonthScheduledDateTo && this.state.data.frequencyMonthScheduledDateFrom) {
                                                    let data = this.state.data;
                                                    let date = new Date(this.state.data.frequencyMonthScheduledDateFrom)
                                                    date.setDate(date.getDate() + 31)
                                                    data.frequencyMonthScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                    this.setData(data)
                                                }
                                            }}
                                        />
                                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                    </Col>
                                    <Col lg="12">
                                        <DatePicker
                                            label={'End date'.translate(this.props.lang) + '*'}
                                            dateFormat={this.props.dateFormat}
                                            minDate={new Date(this.state.data.frequencyMonthScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.data.frequencyMonthScheduledDateFrom) : new Date(this.state.monthDate)}
                                            value={this.state.data.frequencyMonthScheduledDateTo ? this.state.data.frequencyMonthScheduledDateTo : moment(this.state.monthDate).format(this.props.dateFormat)}
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.frequencyMonthScheduledDateTo = e;
                                                this.setData(data)

                                            }}
                                        />
                                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                    </Col>
                                </Row>
                            </div>
                            : null}



                        <div style={{ display: 'flex', marginTop: 15 }}>
                            <Button style={{ margin: 10, marginLeft: 0, marginTop: 0, height: 35 }}
                                disabled={disabledSaveButton}
                                color='primary' onClick={() => {
                                    this.setState({
                                        creatingEvent: true
                                    }, () => {
                                        let id = this.state.data.id ?? this.state.data._id ?? null
                                        if (id) {
                                            this.updateEvent(this.state.data)
                                        }
                                    })


                                }}>
                                {this.state.loading ?

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Player
                                            onEvent={() => {
                                                if (!this.state.loading) this.stopAnimation();
                                            }}
                                            onStateChange={this.toggleVisibility}
                                            ref={this.player} // set the ref to your class instance
                                            autoplay={true}
                                            loop={true}
                                            controls={true}
                                            src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                            style={{ height: "20px", width: "30px" }}
                                        ></Player>
                                        {'Processing...'.translate(this.props.lang)}
                                    </div>

                                    : 'Set'.translate(this.props.lang)}
                            </Button>
                            <Button style={{ margin: 10, marginTop: 0, height: 35 }}
                                disabled={!this.state.loadingDelete && this.state.data && this.state.data.type && (!this.state.data.frequencyType || (this.state.data.frequencyType &&
                                    (this.state.data.frequencyType == 'day' && this.state.data.frequencyDayText && this.state.data.frequencyDayScheduledDateFrom && this.state.data.frequencyDayScheduledDateTo)
                                    || (this.state.data.frequencyType == 'month' && this.state.data.frequencyMonthScheduled && this.state.data.frequencyMonthScheduledDateFrom && this.state.data.frequencyMonthScheduledDateTo)
                                    || (this.state.data.frequencyType == 'week' && (this.state.data.checkedMonday || this.state.data.checkedTuesday || this.state.data.checkedThursday || this.state.data.checkedWednesday || this.state.data.checkedFriday || this.state.data.checkedSaturday || this.state.data.checkedSunday) && this.state.data.frequencyWeekScheduledDateFrom && this.state.data.frequencyWeekScheduledDateTo)
                                ))
                                    ? false : true}
                                color='primary' onClick={() => this.deletePatientTime(this.state.data)}>
                                {this.state.loadingDelete ?

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Player
                                            onEvent={() => {
                                                if (!this.state.loadingDelete) this.stopAnimation();
                                            }}
                                            onStateChange={this.toggleVisibility}
                                            ref={this.player} // set the ref to your class instance
                                            autoplay={true}
                                            loop={true}
                                            controls={true}
                                            src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                            style={{ height: "20px", width: "30px" }}
                                        ></Player>
                                        {'Processing...'.translate(this.props.lang)}
                                    </div>

                                    : 'Cancel time'.translate(this.props.lang)}
                            </Button>
                            <Button
                                style={{ margin: 10, marginTop: 0 }}
                                color='primary'
                                onClick={() => this.toggle()}
                            >
                                {'Cancel'.translate(this.props.lang)}
                            </Button>

                        </div>

                    </ModalBody >


                    <div style={{ margin: '5px 15px' }}>
                        {
                            this.state.data?.tsCreated && this.state.data?.tsModified && this.state.data?.tsCreated !== this.state.data?.tsModified ?
                                <div className='info-message-update-wrap'>
                                    {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.data?.tsCreated, `${this.props.dateFormat} HH:mm`)}. ${'Last update:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.data?.tsModified, `${this.props.dateFormat} HH:mm`)}`}
                                </div>
                                :
                                this.state.data?.tsCreated ?
                                    <div className='info-message-update-wrap'>
                                        {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.data?.tsCreated, `${this.props.dateFormat} HH:mm`)}`}
                                    </div>
                                    :
                                    null

                        }
                    </div>
                </Modal >



                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>

                        :
                        null
                }
                {
                    this.state.wrongDate ?
                        <Modal isOpen={this.state.wrongDate} centered>
                            <ModalBody className="delete-modal">
                                <p className='message'>{'You can not pick date form the past'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className="buttons-right-blue">
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ wrongDate: !this.state.wrongDate })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }

            </>


        )
    }
}

export default UpdateFreeEvent;